<template>
  <div>
    <div data-app v-if="reportData == null && !reportFlag">
      <template v-if="$store.getters.currentMerchant">
        <div class="mt-4">
          <!-- <ValidationObserver> -->
          <template>
            <v-container>
              <!-- ------------------------------------------------ -->
              <h6>
                در صورت نیاز به راهنمای بیشتر روی آیکون
                <i class="fas fa-exclamation-circle text-primary"></i>
                کلیک کنید
              </h6>

              <v-stepper v-model="stepper" vertical>
                <!-- <v-form ref="firstStep" v-model="firstFormValid"> -->
                <v-stepper-step :complete="stepper > 1" step="1">
                  <v-row class="pa-2">
                    <!-- <v-col cols="12"> -->
                    <h5
                      class="text--secondary"
                      v-if="!$store.getters.tradeRequestIsEdit"
                    >
                      انتخاب کالا/خدمات از ارائه دهنده مورد نظر
                    </h5>
                    <h5
                      class="text--secondary"
                      v-else-if="$store.getters.tradeRequestIsEdit && !editFlag"
                    >
                      اطلاعات عمومی
                    </h5>
                    <h5
                      class="text--secondary"
                      v-else-if="$store.getters.tradeRequestIsEdit && editFlag"
                    >
                      ویرایش اطلاعات عمومی
                    </h5>
                    <HelperComponent
                      helperId="trade-request-general-info"
                      class="mx-2"
                    />

                    <!-- </v-col> -->
                  </v-row>
                </v-stepper-step>

                <v-stepper-content step="1">
                  <v-form ref="firstStep" v-model="firstFormValid">
                    <v-sheet
                      outlined
                      class="pa-4 my-4"
                      v-if="
                        !$store.getters.tradeRequestIsEdit ||
                        ($store.getters.tradeRequestIsEdit && editFlag)
                      "
                    >
                      <v-row class="">
                        <v-col cols="12">
                          <v-row>
                            <v-card-text>
                              <supplier-sale-products-list
                                v-if="
                                  isItemsAdding ||
                                  !$store.getters.tradeRequestIsEdit
                                "
                                @selectedDataFunc="selectedDataFunc"
                              />
                            </v-card-text>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              v-if="
                                isItemsAdding ||
                                !$store.getters.tradeRequestIsEdit
                              "
                            >
                              <v-text-field
                                dense
                                outlined
                                readonly
                                label="عنوان کالا یا خدمت انتخاب شده"
                                v-model="SelectedCategoryDetails"
                                required
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'یک کالا یا خدمت مورد نظر برای سفارش را از طریق جستجو، انتخاب کنید',
                                ]"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="!isItemsAdding || editFlag">
                            <v-col cols="12">
                              <v-text-field
                                dense
                                outlined
                                label="توضیحات عمومی"
                                v-model="tradeRequest.content"
                                :required="
                                  tradeRequest.content &&
                                  tradeRequest.content.length > 0
                                "
                                :rules="[
                                  (v) => {
                                    if (
                                      v &&
                                      (v.length > 4096 || v.length < 8)
                                    ) {
                                      return 'تعداد کاراکتر ها باید بین 8 تا 4096 عدد باشد';
                                    } else return true;
                                  },
                                ]"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="!isItemsAdding">
                            <v-col cols="12" md="4" sm="6">
                              <span class="text-right">
                                لطفا مهلت پاسخ دهی را مشخص کنید.*
                              </span>
                            </v-col>

                            <v-col cols="8" sm="6" md="4" lg="3" class="mr-n2">
                              <v-row>
                                <!-- <ValidationProvider name=" مهلت شرکت" rules="required"> -->

                                <v-text-field
                                  v-model="tradeRequest.bidExpirationTimeInDays"
                                  dense
                                  outlined
                                  type="number"
                                  value="1"
                                  placeholder="صفحه کلید به انگلیسی باشد"
                                  style="width: 80px"
                                  suffix="روز"
                                  required
                                  :rules="[
                                    (v) =>
                                      !!v || 'وارد کردن مقدار الزامی می‌باشد',
                                  ]"
                                  class="mx-5"
                                ></v-text-field>
                                <!-- </ValidationProvider> -->
                                <span class="mt-3">
                                  <!-- {{addHoursToDate(tradeRequest.bidExpirationTimeInDays)}} -->
                                  {{
                                    jalaliDate(
                                      addDaysToDate(
                                        tradeRequest.bidExpirationTimeInDays
                                      )
                                    )
                                  }}
                                </span>
                              </v-row>
                            </v-col>
                            <v-col cols="1" md="5"></v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-sheet>
                    <v-card
                      outlined
                      v-else-if="$store.getters.tradeRequestIsEdit && !editFlag"
                    >
                      <v-card-text>
                        <v-row>
                          <v-col cols="12">
                            <label> َ توضیحات عمومی: </label>
                            <strong>
                              {{ tradeRequest.content }}
                            </strong>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                    <v-btn
                      v-if="!$store.getters.tradeRequestIsEdit"
                      color="primary"
                      @click="
                        $refs.firstStep.validate()
                          ? (stepper = 2)
                          : validationErrorModal()
                      "
                      class="my-1"
                    >
                      گام بعد
                    </v-btn>
                    <div v-else>
                      <v-btn
                        v-if="!editFlag"
                        color="primary"
                        @click="editFlag = true"
                        class="my-1"
                      >
                        ویرایش اطلاعات
                      </v-btn>
                      <div v-else>
                        <v-btn
                          class="mx-2 my-1"
                          color="primary"
                          @click="editGeneralInfo()"
                        >
                          ثبت اطلاعات
                        </v-btn>
                        <v-btn
                          class="mx-2 my-1"
                          color="error"
                          @click="editFlag = false"
                        >
                          انصراف
                        </v-btn>
                      </div>
                    </div>
                  </v-form>
                </v-stepper-content>
                <!-- </v-form> -->

                <!-- -------------------------:selectedItemForEdit ="selectedItemForEdit"----------------------- -->

                <v-row>
                  <v-col>
                    <TradeRequestDirectItemForm
                      :formHasItemProp="tradeRequest.items.length > 0"
                      :SelectedCategoryDetails="SelectedCategoryDetails"
                      :selectedSupplierProduct="selectedSupplierProduct"
                      :editBtnPressed="editBtnPressed"
                      @editBtnPressedFunc="editBtnPressedFunc"
                      :reset="reset"
                      :checkRegisterOrderOrEditOrderIsDisableFlag="
                        checkRegisterOrderOrEditOrderIsDisableFlag
                      "
                      @changeReset="reset = false"
                      :stepper="stepper"
                      :bidExpirationInDays="
                        tradeRequest.bidExpirationTimeInDays
                      "
                      @changeStepper="changeStepper"
                      :request="tradeRequest.request"
                      :cannSearchSupplierProductProp="isItemsAdding"
                      @isItemsAddingAction="isItemsAddingAction"
                    
                    />
                  </v-col>
                </v-row>
              </v-stepper>
              <v-col cols="12" class="float-left">
                <v-spacer></v-spacer>
                <v-btn
                  class="float-left"
                  color="primary"
                  @click="addNewItem()"
                  :disabled="!addNewItemBtnEnabled"
                  v-if="addNewItemBtnEnabled"
                >
                  افزودن آیتم جدید
                </v-btn>
              </v-col>
              <transition>
                <v-row class="my-3">
                  <v-col cols="12" class="pa-3">
                    <TradeRequestDirectItems
                      :request="tradeRequest.request"
                      :stepper="stepper"
                      @changeStepper="changeStepper"
                      :trade-request-items="tradeRequest.items"
                      @removeItem="confirmToRemoveItem"
                      @editItemInList="editItemInList"
                    />
                  </v-col>
                </v-row>
              </transition>
            </v-container>

            <v-row class="mt-2">
              <v-col cols="2"></v-col>
              <v-spacer />
              <v-col cols="10" class="float-left text-left pl-5">
                <v-btn
                  v-if="readyToConfirm"
                  :disabled="
                    !readyToConfirm && !$store.getters.tradeRequestIsEdit
                  "
                  @click="viewReport"
                  color="success"
                >
                  بررسی جهت تایید
                </v-btn>
                <v-btn
                  :disabled="!canSubmit"
                  class="mx-2"
                  @click="submit"
                  color="primary"
                >
                  ثبت نهایی
                </v-btn>
                <v-btn @click="closeForm" color="error"> انصراف </v-btn>
              </v-col>
            </v-row>
          </template>
        </div>
        <v-dialog v-model="helpDialog" width="500">
          <v-card>
            <v-card-title>
              {{ help.title }}
            </v-card-title>

            <v-card-text class="mt-3">
              {{ help.text }}
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="helpDialog = false">
                فهمیدم
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <div justify="center" align="center" v-else>
        <h1>لطفا از منوی بالا یک شرکت انتخاب کنید .</h1>
      </div>
    </div>
    <div v-else>
      <trade-request-direct-report
        @reportFlag="
          reportFlag = false;
          reportData = null;
        "
        :reportData="reportData"
      >
      </trade-request-direct-report>
    </div>
  </div>
</template>

<script>
import SupplierSaleProductsList from './SupplierSaleProductsList.vue';
import TradeRequestDirectReport from './TradeRequestDirectReport.vue';
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import TradeRequestDirectItemForm from '@/modules/tradeRequests/components/TradeRequestDirectItemForm.vue';
import { GET_ENUMS } from '../../enums/store/types';
import TradeRequestDirectItems from '@/modules/tradeRequests/components/TradeRequestDirectItems.vue';
import Swal from 'sweetalert2';
import Multiselect from 'vue-multiselect';
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const merchantRepository = () => RepoFactory.get('merchant');
const tradeRequestsRepository = () => RepoFactory.get('tradeRequests');
const enumsRepository = () => RepoFactory.get('enums');
import qs from 'qs';

// const initialTradeRequest = {
//   content: null,
//   request: null,
//   category: null,
//   attachments: [],
//   limitation: null,
//   limitationIds: null,
//   bidExpirationTimeInDays: null,
//   paymentMethod: '',
//   items: [],
//   requestIsForManufaturer: null,
//   runningDuration: null,
//   guarantee: '',
//   urlLink: '',
//   orderDescription: '',
// };

export default {
  mixins: [asyncLoadMixin, reusableMethodsMixin],
  components: {
    TradeRequestDirectItems,
    TradeRequestDirectItemForm,
    Multiselect,
    TradeRequestDirectReport,
    SupplierSaleProductsList,
  },
  data() {
    return {
      editBtnPressed: false,
      reportData: null,
      reportFlag: false,
      submitFlag: false,
      confirmationId: null,
      readyToConfirm: false,
      bidExpirationTimeInDaysFromNow: 0,
      reset: false,
      tradePaymentMethodList: [],
      tradeGuaranteeList: [],
      tradeRequestTypeList: [],
      tradeRequestTypeListSelected: [
        { title: 'DirectOrder', displayName: 'سفارش مستقیم' },
      ],
      tradeCategoriesList: [],
      firstFormValid: true,
      stateName: [],
      cityName: [],
      editFlag: false, //for start to edit form set to true
      isItemsAdding: false, //while items is adding for new item not edit item
      isItemsEditing: false, // while them editing
      addNewItemBtnEnabled: false,
      stateOfCities: [],
      selectedItemForEdit: null,
      tradeRequestsList: [],
      stepper: 1,
      stateIds: [],
      citiesList: [],
      statesList: [],
      limit: false,
      dayNum: 0,
      helpDialog: false,
      showCustomList: false,
      customListItems: [],
      help: {
        title: 'عنوان متن کمکی',
        text: ` متن کمکی`,
      },
      itemsTableFields: [
        {
          value: 'title',
          text: 'عنوان آیتم',
          sortable: true,
        },

        {
          value: 'quantity',
          text: 'تعداد/مقدار',
          sortable: true,
        },

        {
          value: 'actions',
          text: 'اقدام',
        },
      ],

      tradeRequestOrigin: [],
      statesOrCitiesList: [],
      stateOrCitiesLabel: '',
      tradeRequest: {
        content: '',
        request: 'DirectOrder',
        category: null,
        attachments: [],
        limitation: null,
        limitationIds: null,
        bidExpirationTimeInDays: 0,
        paymentMethod: '',
        items: [],
        requestIsForManufaturer: null,
        runningDuration: null,
        guarantee: 'Cheque',
        urlLink: '',
        orderDescription: '',

        supplierId: null,
      },
      selectedSupplierProduct: null,
      checkRegisterOrderOrEditOrderIsDisableFlag: false,
      SelectedCategoryDetails: '',
      selectedCategoryType: '', // For validation on creating order , each order should have unique CategoryType
      selectedSupplierId: '', // For validation on creating order , each order should have unique  supplierId
      canSubmit: false, //Controle to enable submit button
      formHasItem: false,
    
    };
  },
  computed: {
    tradeBaseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    baseUrl() {
      return this.$store.getters.inventoryBaseUrl;
    },
    currentMerchant() {
      return this.$store.getters.currentMerchant;
    },
  },
  async created() {
    //addNewItemBtnEnabled
    this.canSubmit = false;
    if (this.$store.getters.tradeRequestIsEdit && this.stepper != 4) {
      this.addNewItemBtnEnabled = true;
      this.checkRegisterOrderOrEditOrderIsDisableFlag = true;
    }
    if (this.$store.getters.authorize == 'merchant') {
      const loader = this.$loading.show();
      merchantRepository()
        .getAllMerchantsByCurrentUser(this.$store.getters.merchantBaseUrl)
        .then((res) => {
          this.$store.commit('setCurrentMerchant', res.data.merchantId);
        })
        .catch((error) => Helper.handleErrors(error, this))
        .finally(() => loader.hide());
    }
    if (!this.$store.getters.allEnums.length) {
      await this.$store.dispatch(GET_ENUMS);
    }

    this.tradeCategories();
    this.tradeRequestType();
    this.tradePaymentMethod();
    this.tradeGuaranteeMethod();
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.preventNav);
  },
  mounted() {
    console.log(this.tradeRequest);
    if (
      this.$store.getters.tradeRequestIsEdit ||
      (this.$route.params.id && this.$route.params.id.length)
    ) {
      this.$store.commit('setTradeRequestIsEdit', true);
      const loader = this.$loading.show();
      tradeRequestsRepository()
        .getTradeRequestById(this.$route.params.id, this.tradeBaseUrl)
        .then((res) => {
          this.$store.commit('setTradeRequestFormStatus', true);
          this.$store.commit('setTradeRequestSelectedForEdit', res.data);
          this.$store.commit('setTradeRequestShowDetailForm', false);
          this.$store.commit('setTradeRequestSelectedForDisplay', null);

          //َSupdate SelectedSupplierId if edit mode setTradeRequestSelectedItem

          console.log('data is ');
          console.log(res.data);
          this.tradeRequest.supplierId = res.data.supplierId;
          this.selectedCategoryType = res.data.categoryType;
          let seletedproarr = [];
          seletedproarr.push(res.data);
          this.selectedSupplierProduct = seletedproarr;
          // this.tradeRequest.urlLink =
          //   res.data.supplierProduct.images[0]?.fileUrl;

          this.fillInput();
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    } else {
    }
    this.getCategoryTypeItems();
    this.getLimitationEnum();
  },
  destroyed() {
    this.resetForm();
  },
  methods: {
    isItemsAddingAction(val) {
      console.log('isItemsAddingAction func runing val is :' + val);
      this.isItemsAdding = val;
    },
    selectedDataFunc(selected) {
      this.selectedSupplierProduct = selected;
      this.tradeRequest.supplierId = this.selectedSupplierProduct[0].supplierId;

      this.tradeRequest.category = this.selectedSupplierProduct[0].categoryType;

      console.log('ggggggg');
      console.log(this.selectedSupplierProduct[0]);
      this.tradeRequest.orderDescription =
        'درخواست قیمت از  : ' +
        this.selectedSupplierProduct[0].supplierName +
        ' برای : ' +
        this.selectedSupplierProduct[0].name;
      

      this.tradeRequest.urlLink =
        this.selectedSupplierProduct[0].mainImage?.fileUrl;
      if (this.selectedSupplierId == '' && this.selectedCategoryType == '') {
        this.selectedSupplierId = this.selectedSupplierProduct[0].supplierId;
        this.selectedCategoryType =
          this.selectedSupplierProduct[0].categoryType;
      } else {
        //Generate Error
        //Validating of Unique CategoryType And Unique SupplierId in one Order
        if (
          this.selectedSupplierProduct[0].supplierId !=
            this.selectedSupplierId ||
          this.selectedSupplierProduct[0].categoryType !=
            this.selectedCategoryType
        ) {
          this.SelectedCategoryDetails = '';
          this.$dialog.error({
            text: 'هر سفارش باید برای یک تامین کننده باشد، در انتخاب مالا یا خدمات تامین کنندگان دقت فرمایید ',
            title: 'خطا',
            persistent: true,
            actions: [
              {
                text: 'بستن',
                color: 'red',
              },
            ],
          });
          return;
        }
      }

      this.SelectedCategoryDetails =
        this.translate(this.selectedSupplierProduct[0].categoryType) +
        ' / ' +
        this.selectedSupplierProduct[0].name +
        ' / تامین کننده : ' +
        this.selectedSupplierProduct[0].supplierName;
    },
    async editGeneralInfo() {
      let app = this;
      await app.submit();
      app.editFlag = false;
      this.$store.commit('setTradeRequestIsEdit', true);
      this.$store.getters.tradeRequestIsEdit;
    },
    editBtnPressedFunc(val) {
      this.editBtnPressed = val;
      if (val) {
        //this.isItemsAdding = false; //the watcher on singleitem not working if set to false
        this.canSubmit = true;
      }
    },
    getDataById(id) {
      const loader = this.$loading.show();
      tradeRequestsRepository()
        .getTradeRequestById(id, this.tradeBaseUrl)
        .then((res) => {
          this.$store.commit('setTradeRequestSelectedForEdit', res.data);
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
    addNewItem() {
      this.isItemsAdding = true;
      this.canSubmit = false;
      this.readyToConfirm = false;
      this.$store.commit('setTradeRequestSingleItem', null);
      //this.$store.commit('setTradeRequestEditMode', false);//ٔقت شود اگر در حالت ویرایش سفارش است می‌تواند قلم جدید اصافه کند و حالت ویرایش عوض نشود
      this.$store.commit('setTradeRequestSingleItemForEdit', null);
      this.stepper = 2;
      this.reset = true;
      this.checkRegisterOrderOrEditOrderIsDisableFlag = false;
    },
    resetForm() {
      //this.isItemsAdding = false;
      this.readyToConfirm = false;
      this.editBtnPressed = false;
      (this.reportData = null),
        (this.reportFlag = false),
        (this.submitFlag = false);
      this.tradePaymentMethodList = [];
      this.tradeGuaranteeList = [];
      this.tradeRequestTypeList = [];
      this.tradeRequestTypeListSelected = [];
      this.tradeCategoriesList = [];
      this.firstFormValid = true;
      this.stateName = [];
      this.cityName = [];
      (this.editFlag = false), (this.stateOfCities = []);
      this.selectedItemForEdit = null;
      this.tradeRequestsList = [];
      this.stepper = 1;
      this.canSubmit = false;
      this.stateIds = [];
      this.citiesList = [];
      this.statesList = [];
      this.limit = false;
      this.dayNum = 0;
      this.helpDialog = false;
      this.showCustomList = false;
      this.customListItems = [];
      this.statesOrCitiesList = [];
      this.stateOrCitiesLabel = '';
      this.tradeRequest.category = null;
      this.tradeRequest.request = 'DirectOrder';
      this.tradeRequest.paymentMethod = '';
      this.tradeRequest.limitation = null;
      (this.tradeRequest.runningDuration = null),
        (this.tradeRequest.guarantee = 'Cheque'),
        (this.tradeRequest.urlLink = ''),
        (this.tradeRequest.orderDescription = ''),
        (this.tradeRequest.limitationIds = null);
      this.tradeRequest.bidExpirationTimeInDays = null;
      this.tradeRequest.items = [];
    },
    validationErrorModal() {
      this.$dialog.error({
        text: 'وارد کردن موارد ستاره دار الزامی می‌باشد',
        title: 'خطا',
        persistent: true,
        actions: [
          {
            text: 'بستن',
            color: 'red',
          },
        ],
      });
    },
    // changeCategory(val) {
    //   this.category = val;
    // },
    fillInput() {
      this.getLimitationEnum();
      this.tradeRequest = this.$store.getters.tradeRequestSelectedForEdit;
      //this.tradeRequest.bidExpirationTimeInDays = this.tradeRequest.bidExpirationTimeInDaysFromNow;
      this.bidExpirationTimeInDaysFromNow =
        this.tradeRequest.bidExpirationTimeInDaysFromNow;
      if (
        this.$store.getters.tradeRequestSelectedForEdit.limitation == 'State'
      ) {
        this.tradeRequest.limitation = 'State';
        this.limit = true;
        this.getStates();
        this.$store.getters.tradeRequestSelectedForEdit.limitationsDtos.forEach(
          (x) => {
            this.stateIds.push(x.id);
            this.stateName.push(x.value);
          }
        );
      }
      if (
        this.$store.getters.tradeRequestSelectedForEdit.limitation == 'City'
      ) {
        this.tradeRequest.limitation = 'City';
        this.tradeRequest.limitationIds = [];
        this.limit = true;
        this.getStates();
        this.$store.getters.tradeRequestSelectedForEdit.limitationsDtos.forEach(
          (x) => {
            this.tradeRequest.limitationIds.push(x.id);
            this.cityName.push(x.value);
            this.stateIds.push(x.stateId);
            this.stateName.push(x.stateName);
          }
        );
        this.tradeRequest.limitationIds = Array.from(
          new Set(this.tradeRequest.limitationIds)
        );
        this.stateIds = Array.from(new Set(this.stateIds));
        this.stateName = Array.from(new Set(this.stateName));

        // this.getCitiesByCityIds(this.tradeRequest.limitationIds);
      }
      this.tradeRequest.items.forEach((item) => {
        this.addItemToList(item);
      });
    },
    getCategoryTypeItems() {
      return new Promise((resolve, reject) => {
        enumsRepository()
          .getEnum('CategoryTypeItems', this.$store.getters.productBaseUrl)
          .then(({ data }) => {
            this.tradeRequestsList = data;
            resolve();
          })
          .catch((err) => {
            Helper.handleErrors(err, this);
          });
      });
    },
    changeStepper(val) {
      this.stepper = val;
      console.log('changing stepper vale => ' + val);
    },
    async submit() {
      let body;
      if (this.$store.getters.tradeRequestIsEdit) {
        body = {
          content: this.tradeRequest.content,
          request: this.tradeRequest.request,
          category: this.tradeRequest.category,
          runningDuration: this.tradeRequest.runningDuration,
          guarantee: this.tradeRequest.guarantee,
          urlLink: this.tradeRequest.urlLink,
          orderDescription: this.tradeRequest.orderDescription,
          attachments: [],
          items: [],
          limitation: this.tradeRequest.limitation,
          limitationIds: this.tradeRequest.limitationIds,
          bidExpirationTimeInDays: this.tradeRequest.bidExpirationTimeInDays,
          paymentMethod: this.tradeRequest.paymentMethod,
          requestIsForManufaturer: this.tradeRequest.requestIsForManufaturer,
          supplierId: this.tradeRequest.supplierId,
        };
        let item;
        this.tradeRequest.items.forEach((x, i) => {
          if (x.uniqueId) {
            delete x.uniqueId;
          }
          item = {
            id: x.id ? x.id : null,
            title: x.title,
            quantity: x.quantity,
            requireDateUtc: x.requireDateUtc,
            description: x.description,
            materialSupplyType: x.materialSupplyType,
            rawMaterialId: x.rawMaterialId,
            measurementUnitId: x.measurementUnitId,
            inventoryItemId: x.inventoryItemId,
            deliveryType: x.deliveryType,
            deliveryLocation: x.deliveryLocation,
            tradeRequestItemType: x.tradeRequestItemType,
            technicalHelpNeeded: x.technicalHelpNeeded,
            supplierProductId: x.supplierProductId,
          };
          let documents = [],
            techInfos = [],
            deliveryItems = [],
            responseDocuments = [];
          x.documents.forEach((dx, di) => {
            documents.push({
              categoryType: dx.categoryType,
              id: dx.id ? dx.id : null,
              documentTypeId: dx.documentTypeId,
              description: dx.description,
              expirationDateUtc: dx.expirationDateUtc,
              fileId:
                typeof dx.fileId == 'string' ? dx.fileId : dx.fileId.fileId,
            });
          });
          x.responseDocuments.forEach((rdx, rdi) => {
            responseDocuments.push({
              id: rdx.id ? rdx.id : null,
              documentTypeId: rdx.documentTypeId,
              isOptional: rdx.isOptional,
              subTitle: rdx.subTitle,
            });
          });
          x.techInfos.forEach((tx, ti) => {
            techInfos.push({
              id: tx.id ? tx.id : null,
              processType: tx.processType,
              productCategoryId: tx.productCategoryId,
              tradeRequestItemPropertyValues: tx.tradeRequestItemPropertyValues,
            });
          });
          x.deliveryItems.forEach((dlx, dli) => {
            deliveryItems.push({
              id: dlx.id ? dlx.id : null,
              amount: dlx.amount,
              deliveryDateUtc: dlx.deliveryDateUtc,
            });
          });
          item.documents = documents;
          item.techInfos = techInfos;
          item.responseDocuments = responseDocuments;
          item.deliveryItems = deliveryItems;
          body.items.push(item);
        });
        this.canSubmit = false;
        this.isItemsAdding = false;
      } else {
        // console.log(this.tradeRequest);
        this.tradeRequest.items.forEach((x, i) => {
          if (x.uniqueId) {
            delete x.uniqueId;
          }
        });
        body = { ...this.tradeRequest };

        if (
          this.tradeRequest.merchantId &&
          this.tradeRequest.merchantId.length
        ) {
          body = { ...body };
        } else {
          body = {
            merchantId: this.currentMerchant,
            ...body,
          };
        }
      }
      body.items.forEach((item) => {
        if (item.document && item.document.length) {
          item.documents.forEach((x) => {
            if (x.fileUniqueId) {
              delete x.fileUniqueId; //////// have been changed
            }
          });
        }
        if (item.responseDocuments && item.responseDocuments.length) {
          item.responseDocuments.forEach((x) => {
            if (x.responseDocumentId) {
              delete x.responseDocumentId;
            }
          });
        }
        if (item.technicalHelpNeeded) {
          item.techInfos = null;
        }
      });
      this.canSubmit = false;
      this.isItemsAdding = false;
      //console.log('body', body);
      const loader = this.$loading.show();
      if (this.$store.getters.tradeRequestIsEdit) {
        await tradeRequestsRepository()
          .editDirectOrderTradeRequest(
            this.tradeRequest.id,
            body,
            this.tradeBaseUrl
          )
          .then((res) => {
            this.$dialog.message.success(
              ' سفارش مورد نظر با موفقیت ویرایش شد. ',
              {
                position: 'top-left',
              }
            );
            this.submitFlag = false;
            this.isItemsAdding = false;
            this.canSubmit = false;
            this.confirmationId = this.tradeRequest.id;
            this.$store.commit('setTradeRequestIsEdit', false);
            this.readyToConfirm = true;
            loader.hide();
            this.closeForm(); //by closing form all tem data in stors being cleared
            this.$router.push(
              `/trade-request-direct-report/${this.tradeRequest.id}`
            );
          })
          .catch((err) => {
            console.log(err);
            Helper.handleErrors(err, this);
            loader.hide();
          })
          .finally(() => loader.hide());
      } else {
        await tradeRequestsRepository()
          .addTradeRequestDirect(body, this.tradeBaseUrl)
          .then((res) => {
            this.$dialog.message.success(' سفارش جدید با موفقیت ثبت گردید. ', {
              position: 'top-left',
            });
            this.submitFlag = true;
            this.isItemsAdding = false;
            this.readyToConfirm = true;
            this.confirmationId = res.data.id;
            this.getDataById(this.confirmationId);
            loader.hide();
            this.closeForm();
            this.$router.push(`/trade-request-direct-report/${res.data.id}`);
          })
          .catch((error) => {
            // if (error.response.status == '406') {
            //   this.changeStatusMassage = error.response.data.messages;
            //   this.changeStatusToken = error.response.data.confirmationToken;
            //   this.changeStatusModal = true;
            //   this.selectedCategoryForChangeStatus = this.selectedCategory;
            // } else {
            //   Helper.handleErrors(error, this);
            // }

            Helper.handleErrors(error, this);
          })
          .finally(() => loader.hide());
      }
    },
    addDaysToDate(intDays) {
      var currentDateObj = new Date();
      var numberOfMlSeconds = currentDateObj.getTime();
      var addMlSeconds = intDays * 24 * 60 * 60 * 1000;
      var newDateObj = new Date(numberOfMlSeconds + addMlSeconds);
      return newDateObj;
    },
    closeChangeStatusModal() {
      this.changeStatusMassage = [];
      this.changeStatusToken = null;
      this.changeStatusModal = false;
      this.selectedCategoryForChangeStatus = null;
    },
    getLimitationEnum() {
      enumsRepository()
        .getEnum('TradeRequestLimitationType', this.tradeBaseUrl)
        .then((res) => {
          this.tradeRequestOrigin = res.data.filter((x) => {
            if (x.title != 'Country') return x;
          });
        })
        .catch((err) => Helper.handleErrors(err, this));
    },
    openHelpModal() {
      // Send Request To Get Help Text
      this.helpDialog = true;
    },
    preventNav(event) {
      event.preventDefault();
      event.returnValue = '';
    },
    addItemToList(item) {
      //we should controle 3 mode
      ///Case 1/سفارش در حال ایجاد بوده و اقلام سفارش می توانند اضافه شوند، ، اضافه شده ویرایش شود
      ///Case 2/سفارش ثبت شده قبلی قابل ویرایش جهت ویرایش انتخاب شده و اقلام موجود ویرایش شده، اقلام جدید اضافه شوند یا ویرایش شوند
      //All the case we should check the unique Supplier for all items
      console.log('AddItemToList Func in DirectForm');
      let app = this;
      //check unique supplier
      if (item && Object.keys(item).length > 0) {
      }

      if (
        !this.$store.getters.tradeRequestEditMode &&
        !this.$store.getters.tradeRequestItemEditMode
      ) {
        //create new Item for new TradeRequest
        if (item && Object.keys(item).length) {
          this.$store.commit('addItemToTradeRequestItems', item); // push item => state.tradeRequestItems.push(payload)
          app.tradeRequest.items = [];
          app.tradeRequest.items = this.$store.getters.tradeRequestItems;
          this.$store.commit('setTradeRequestSingleItem', null);
          return;
        }
      } else if (
        // this.$store.getters.tradeRequestEditMode &&
        // !this.$store.getters.tradeRequestIsEdit
        this.$store.getters.tradeRequestEditMode &&
        !this.$store.getters.tradeRequestItemEditMode
      ) {
        //Add an Item in a alredy tradeRequest
        // this.$store.getters.tradeRequestItems.forEach((x, i) => {
        //   if (x.uniqueId && item.uniqueId && x.uniqueId == item.uniqueId) {
        //     app.tradeRequest.items[i] = item;
        //     this.$store.commit('setTradeRequestItems', app.tradeRequest.items);
        //     app.tradeRequest.items = [];
        //     this.$store.commit('setTradeRequestSingleItemForEdit', null);
        //     app.tradeRequest.items = this.$store.getters.tradeRequestItems;
        //     this.$store.commit('setTradeRequestSingleItem', null);
        //     this.$store.commit('setTradeRequestEditMode', false);
        //     return;
        //   }
        // });
        if (item && Object.keys(item).length) {
          this.$store.commit('addItemToTradeRequestItems', item); // push item => state.tradeRequestItems.push(payload)
          app.tradeRequest.items = [];
          app.tradeRequest.items = this.$store.getters.tradeRequestItems;
          this.$store.commit('setTradeRequestSingleItem', null);
          return;
        }
      }

      // else if (
      //   !this.$store.getters.tradeRequestEditMode &&
      //   this.$store.getters.tradeRequestIsEdit
      // ) {
      //   //when user edits one form, the items should be added to itemList
      //   if (item && Object.keys(item).length) {
      //     this.$store.commit('addItemToTradeRequestItems', item); // غلط، باید ویرایش کند نه اینکه پوش کند
      //     app.tradeRequest.items = [];
      //     app.tradeRequest.items = this.$store.getters.tradeRequestItems;
      //     this.$store.commit('setTradeRequestSingleItem', null);
      //     return;
      //   }
      // } else if (
      //   this.$store.getters.tradeRequestEditMode &&
      //   this.$store.getters.tradeRequestIsEdit
      // ) {
      //   //either tradeRequestEditMode and StoreEdit Mode... when user wants to edit an item of previously created form

      //   if (
      //     this.$store.getters.tradeRequestItems &&
      //     this.$store.getters.tradeRequestItems.length
      //   ) {
      //     this.$store.getters.tradeRequestItems.forEach((x, i) => {
      //       if (x.id && x.id == item.id) {
      //         app.tradeRequest.items[i] = item;
      //         this.$store.commit(
      //           'setTradeRequestItems',
      //           app.tradeRequest.items
      //         );
      //         app.tradeRequest.items = [];
      //         app.tradeRequest.items = this.$store.getters.tradeRequestItems;
      //         this.$store.commit('setTradeRequestSingleItem', null);
      //         this.$store.commit('setTradeRequestEditMode', false);
      //         this.$store.commit('setTradeRequestSingleItemForEdit', null);
      //         return;
      //       } else if (!x.id) {
      //         this.$dialog.error({
      //           text: 'ooops!store edit mode without id',
      //           title: 'خطا',
      //           persistent: true,
      //           actions: [
      //             {
      //               text: 'بستن',
      //               color: 'red',
      //             },
      //           ],
      //         });
      //       }
      //     });
      //   }
      // }
    },
    editItemInList(item) {
      console.log('editItemInList func entry');
      let app = this;
      //check tradeRequestEditMode to set tradeRequestIsEdit
      if (this.$store.getters.tradeRequestEditMode) {
        this.$store.commit('SetTradeRequestIsEdit', true);
        this.$store.commit('setTradeRequestItemEditMode', true);
      }
      // app.tradeRequest.items = [];
      // app.tradeRequest.items = this.$store.getters.tradeRequestItems;
      this.$store.commit('setTradeRequestSingleItem', null);
      this.$store.commit('setTradeRequestSingleItemForEdit', item);
    },
    confirmToRemoveItem(item) {
      Swal.fire({
        text: 'برای حذف این مورد مطمئن هستید؟',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'خیر(لغو)',
        confirmButtonText: 'حذف',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.removeItem(item);

          if (this.tradeRequest.items.length > 0) {
            this.editFlag = false;
            this.canSubmit = true;
          }
          if (this.tradeRequest.items.length == 0) {
            this.canSubmit = false;
          }
        }
      });
    },

    removeItem(item) {
      this.$store.getters.tradeRequestItems.splice(
        this.$store.getters.tradeRequestItems.indexOf(
          this.$store.getters.tradeRequestItems.find((el) => el.id === item.id)
        ),
        1
      );
      // this.tradeRequestItems =[]
      // this.tradeRequestItems =this.$store.getters.tradeRequestItems
      this.tradeRequest.items = [];
      this.tradeRequest.items = this.$store.getters.tradeRequestItems;
    },
    closeForm() {
      this.$store.commit('setTradeRequestSelectedForEdit', null);
      this.$store.commit('setTradeRequestSelectedForDisplay', null);
      this.$store.commit('setTradeRequestSingleItemForEdit', null);
      this.$store.commit('setTradeRequestItems', []);
      this.$store.commit('setTradeRequestSingleItem', null);
      this.$store.commit('setAllTradeRequests', []);
      this.$store.commit('setTradeRequestFormStatus', false);
      this.$store.commit('setTradeRequestIsEdit', false);
      this.$store.commit('setTradeRequestEditMode', false);
      this.$store.commit('setTradeRequestItemEditMode', false);
      this.$store.commit('setTradeRequestShowDetailForm', false);
      this.resetForm();
      this.$router.push({ path: '/trade-request-direct' });
    },
    //Start to edit an Item
    // editItem(item) {
    //   console.log('edit item data in main form');
    //   console.log(item);
    //   this.editBtnPressed = true;
    //   this.isItemsAdding = false;
    //   this.$store.commit('setTradeRequestItemEditMode', true);

    //  this.$store.commit('setTradeRequestSingleItemForEdit', item);
    // },
    tradeCategoryDisplayName(title) {
      if (this.tradeCategoriesList.length) {
        let result = this.tradeCategoriesList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    tradeRequestDisplayName(title) {
      if (this.tradeRequestTypeList.length) {
        let result = this.tradeRequestTypeList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    paymentMethodDisplayName(title) {
      if (this.tradePaymentMethodList.length) {
        let result = this.tradePaymentMethodList.find(
          (el) => el.title == title
        );
        if (result) return result.displayName;
      }
    },
    guaranteeMethodDisplayName(title) {
      if (this.tradeGuaranteeList.length) {
        let result = this.tradeGuaranteeList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    tradeGuaranteeMethod() {
      this.tradeGuaranteeList = this.getEnumByTitle('GuaranteeType');
    },
    tradeCategories() {
      this.tradeCategoriesList = this.getEnumByTitle('CategoryTypeItems');
    },
    tradeRequestType() {
      this.tradeRequestTypeList = this.getEnumByTitle('TradeRequestType');
      this.tradeRequestTypeListSelected = [
        { title: 'DirectOrder', displayName: 'سفارش مستقیم' },
      ];
    },
    tradePaymentMethod() {
      this.tradePaymentMethodList = this.getEnumByTitle(
        'TradePaymentMethodType'
      );
    },

    rawMaterialSupplyTypes() {
      return this.getEnumByTitle('RawMaterialSupplyType');
    },
    getStates() {
      merchantRepository()
        .getProvince(this.merchantBaseUrl)
        .then((res) => {
          this.statesList = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
    getCitiesByStateIds() {
      let params = {
        stateIds: this.stateIds,
      };
      merchantRepository()
        .getCitiesOfMultipleStatesTree(
          this.merchantBaseUrl,
          params,
          {},
          (params) => {
            return qs.stringify(params, { arrayFormat: 'repeat' });
          }
        )
        .then((res) => {
          this.citiesList = res.data;
        });
    },

    normalizerCityList(content) {
      let object = {
        isDisabled: content.disabled,
        id: content.id,
        label: content.value,
      };
      if (content.cityList && content.cityList.length) {
        object.children = content.cityList;
      } else {
        delete content.cityList;
      }

      return object;
    },
    viewReport() {
      this.submitFlag = false;
      this.reportFlag = true;
      this.reportData = this.$store.getters.tradeRequestSelectedForEdit;
    },
    translate(en) {
      const Fa = {
        IndustrialService: 'ساخت و تولید',
        Product: 'کالای صنعتی',
        ConsultingService: 'طراحی و مشاوره صنعتی',
        ElectronicDocument: 'استانداردهای صنعتی',
      };

      return Fa[en];
    },
  },
  /////
  watch: {
    canSubmit(after, before) {},
    stepper(after, before) {
      if (this.isItemsAdding && after != 5) {
        this.addNewItemBtnEnabled = false;
        this.canSubmit = false;
      }
      if (after == 5 && before == 4) {
        this.addNewItemBtnEnabled = false;
        this.canSubmit = true;
      }
      if (this.tradeRequest.items.length == 0) {
        this.addNewItemBtnEnabled = false;
        this.canSubmit = false;
      }
      if (this.tradeRequest.items.length > 0 && this.stepper == 5) {
        this.addNewItemBtnEnabled = true;
        this.canSubmit = true;
      }
      if (this.tradeRequest.items.length > 0 && this.stepper != 5) {
        this.addNewItemBtnEnabled = false;
        this.canSubmit = false;
      }
      if (this.stepper == 5) {
        console.log('this.stepper == 5 running');
        this.addNewItemBtnEnabled = true;
        this.canSubmit = true;
      }
      // !isItemsAdding || tradeRequest &&
      //               ((!$store.getters.tradeRequestIsEdit &&
      //                 !$store.getters.tradeRequestEditMode &&
      //                 tradeRequest.items.length != 0) ||
      //                 ($store.getters.tradeRequestIsEdit &&
      //                   !editFlag &&
      //                   stepper != 2))
    },
    bidExpirationTimeInDaysFromNow() {
      this.tradeRequest.bidExpirationTimeInDays =
        this.bidExpirationTimeInDaysFromNow;
    },
    stateIds() {
      if (this.tradeRequest.limitation == 'City' && this.stateIds.length) {
        this.getCitiesByStateIds();
      } else if (
        this.tradeRequest.limitation == 'State' &&
        this.stateIds.length
      ) {
        this.tradeRequest.limitationIds = this.stateIds;
      }
      if (this.stateIds == [] || this.stateIds == '' || this.stateIds == null) {
        this.citiesList = [];
        this.tradeRequest.limitationIds = null;
      }
    },

    limit() {
      if (this.limit == false) {
        this.stateIds = [];
        this.citiesList = [];
        this.statesList = [];
        this.limitationId = null;
        this.tradeRequest.limitation = null;
      }
    },
    'tradeRequest.limitation': function () {
      if (this.$store.getters.tradeRequestIsEdit) {
        this.getStates();
      } else {
        this.stateIds = [];
        this.getStates();
      }
    },
    'tradeRequest.category': function () {
      if (this.tradeRequest.category != 'Product') {
        this.tradeRequest.requestIsForManufaturer = null;
      } else if (!this.$store.getters.tradeRequestIsEdit) {
        this.tradeRequest.requestIsForManufaturer = false;
      }
      this.$store.commit(
        'setTradeRequestCategoryType',
        this.tradeRequest.category
      );
    },
    '$store.getters.tradeRequestSingleItem': function () {
      console.log('tradeRequestSingleItem watcher');
      if (this.$store.getters.tradeRequestSingleItem) {
        console.log(
          'Inside if cluse with this.isItemsAdding value is ' +
            this.isItemsAdding
        );
        //we should check if the item is in edit mode or it is new to add to items
        // this.addItemToList(this.$store.getters.tradeRequestSingleItem);
        if (this.isItemsAdding) {
          this.addItemToList(this.$store.getters.tradeRequestSingleItem);
        } else {
          // this.editItemInList(this.$store.getters.tradeRequestSingleItem);
          this.$store.commit(
            'editItemInTradeRequestItems',
            this.$store.getters.tradeRequestSingleItem
          );
          console.log('tradeRequestItems');
          console.log(this.$store.getters.tradeRequestItems);
        }
      }
    },
    '$store.getters.tradeRequestItems': function () {
      this.tradeRequest.items = [];
      this.tradeRequest.items = this.$store.getters.tradeRequestItems;

      this.formHasItem = this.tradeRequest.items.length > 0;
    },
  },
};
///
//};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
/* .vue-treeselect__menu-container div {
  z-index: 999999999;
} */
</style>
